// @flow
import React, { Component } from "react";
import { noop } from "lodash";

import type { NullaryFn, BinaryFn } from "@tvg/types/Functional";
import type { HandicapOptionsType } from "@tvg/types/Race";
import handicappingOptions, {
  handicappingGreyhoundOptions
} from "@tvg/utils/handicapping-conf/handicappingOptions";

import Icon from "../../_static/Icons";
import { success, star } from "../../_static/Icons/icons";
import MessageBox from "../../_molecule/MessageBox";
import InlineInfo from "../../_atom/InlineInfo";

import buildColor from "../../_static/ColorPalette";
import {
  HandicapItemWrapper,
  ButtonWrapper,
  LoginMessageWrapper,
  Circle,
  FavoriteWrapper,
  DefaultInfo
} from "./styled-components";

type Props = {
  /**
   * favorite handicapping type
   */
  favoriteItem: HandicapOptionsType,
  /**
   * active handicapping type
   */
  activeItem: HandicapOptionsType,
  /**
   * callback for clicking login button
   */
  loginCallBack: NullaryFn<mixed>,
  /**
   * callback for signup login button
   */
  signupCallBack: NullaryFn<mixed>,
  /**
   * callback for selecting the favorite type
   */
  onFavoriteHandicapSelect: BinaryFn<HandicapOptionsType, string, mixed>,
  /**
   * callback for selecting the handicapping type
   */
  onHandicapSelect: BinaryFn<HandicapOptionsType, string, mixed>,
  /**
   * is user logged in
   */
  isLogged: boolean,
  /**
   * if the race is for greyhounds
   */
  isGreyhound: boolean,
  /**
   * show favorite button
   */
  showFavorite: boolean
};

export default class HandicappingList extends Component<Props> {
  static defaultProps = {
    favoriteItem: "basic",
    activeItem: "basic",
    onCLose: noop,
    onFavoriteHandicapSelect: noop,
    onHandicapSelect: noop,
    loginCallBack: noop,
    signupCallBack: noop,
    isLogged: false,
    isGreyhound: false,
    showFavorite: true
  };

  renderOptions = () => {
    const options = this.props.isGreyhound
      ? handicappingGreyhoundOptions
      : handicappingOptions;
    return options.map((option) => (
      <HandicapItemWrapper
        onTouchStart={noop}
        data-qa-label={option.qaLabel}
        key={`${option.key} - ${
          this.props.isGreyhound ? "greyhound" : "horse"
        }`}
        showFavorite={this.props.showFavorite && this.props.isLogged}
      >
        {this.props.showFavorite && this.props.isLogged && (
          <FavoriteWrapper
            onClick={() =>
              this.props.onFavoriteHandicapSelect(
                option.key,
                option.description
              )
            }
            data-qa-label={`${option.qaLabel}Favorite`}
          >
            <Icon
              size={16}
              icon={star}
              color={
                this.props.favoriteItem === option.key
                  ? buildColor("yellow", "500")
                  : buildColor("grey", "100")
              }
              qaLabel={
                this.props.favoriteItem === option.key
                  ? "favorite"
                  : "nonFavorite"
              }
            />
          </FavoriteWrapper>
        )}
        <ButtonWrapper
          onClick={() =>
            this.props.onHandicapSelect(option.key, option.description)
          }
          data-qa-label={`${option.qaLabel}Btn`}
        >
          <InlineInfo title={option.description} info={option.handicapData} />
          {this.props.activeItem === option.key ? (
            <Icon
              size={16}
              icon={success}
              color={buildColor("blue_accent", "500")}
              qaLabel="active"
            />
          ) : (
            <Circle
              size={16}
              borderColor={buildColor("grey", "100")}
              data-qa-label="nonActive"
            />
          )}
        </ButtonWrapper>
      </HandicapItemWrapper>
    ));
  };

  render() {
    const showDefaultLabel = this.props.isLogged && this.props.showFavorite;

    return (
      <section>
        {!this.props.isLogged && (
          <LoginMessageWrapper>
            <MessageBox
              message="Please login to view in-line handicapping"
              type="info"
              onLoginCallback={this.props.loginCallBack}
              onSignupCallback={this.props.signupCallBack}
            />
          </LoginMessageWrapper>
        )}
        {showDefaultLabel && (
          <DefaultInfo data-qa-label="handicapInfoLabel">
            Set as default handicapping info
          </DefaultInfo>
        )}
        <ul>{this.renderOptions()}</ul>
      </section>
    );
  }
}
